import { type Root } from "mdast";
import { type Plugin } from "unified";
import { CONTINUE, visit } from "unist-util-visit";
import { parse } from "yaml";

declare module "vfile" {
	interface DataMap {
		matter: Record<string, unknown>;
	}
}

export const remarkYamlMatter: Plugin<[], Root, unknown> = () => {
	return function (tree, file) {
		visit(tree, "yaml", (node, index, parent) => {
			if (!parent || index === undefined) {
				return CONTINUE;
			}

			const parsed = parse(node.value) as Record<string, unknown>;
			file.data.matter = parsed;
			// Remove the parsed yaml frontmatter from the tree,
			// so that other plugins don't have to worry about it
			parent.children.splice(index, 1);
		});
	};
};
